import { ReactEditor, useEditor as slateUseEditor, useSlate as slateUseSlate } from 'slate-react';

import { Entities } from '../entities';

export interface ReactEditorWithEntities extends ReactEditor {
  entitiesRef: React.MutableRefObject<Entities>;
  setEntities(updateFn: (existing: Entities) => Entities): void;
}

export const useSlate: () => ReactEditorWithEntities = (slateUseSlate as unknown) as () => ReactEditorWithEntities;

export const useEditor: () => ReactEditorWithEntities = (slateUseEditor as unknown) as () => ReactEditorWithEntities;
